<template>
  <transition name="el-zoom-in-center">
    <el-card v-show="update.show" class="box-card" style="text-align: left;">
      <div slot="header" class="clearfix">
        <el-row>
          <el-col :span="12">
            <h3>修改包装关系</h3>
          </el-col>
          <el-col :span="12">
            <el-button style="float: right;" type="primary" @click="update.show=false">收起</el-button>
          </el-col>
        </el-row>
      </div>
      <el-form ref="form" :model="update.form" label-width="110px" :rules="rules">
        <el-row>
          <el-col :span="18" :offset="6">
            <el-form-item label="包装级别" prop="package_level">
              <el-select v-model="update.form.package_level" disabled type="text" style="width:200px">
                <el-option
                  v-for="item in package_levellist"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="包装单位" prop="package_unit_cn">
              <el-select
                v-model="update.form.package_unit_code"
                type="text"
                style="width:200px"
                @change="getpackageunitname($event)"
              >
                <el-option
                  v-for="item in unitpagelist"
                  :key="item.product_unit_code"
                  :label="item.product_unit_cn"
                  :value="item.product_unit_code"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div>
        <br>
        <div style="text-align: center;">
          <el-button style="margin-top: 12px;" @click="resetForm('form')">重置</el-button>
          <el-button style="margin-top: 12px;" type="primary" @click="submitadd('form')">提交</el-button>
        </div>
      </div>
    </el-card>
  </transition>
</template>

<script>
import PanThumb from '@/components/PanThumb'
import { workorderpackedit } from '@/api/plant'
import { productunitpagelist } from '@/api/base'
export default {
  components: { PanThumb },
  props: {
    search: {
      type: Function,
      default: null
    },
    update: {
      type: Object,
      default: () => {
        return {
          show: false,
          form: {
            workorder_senior_id: this.$route.query.id,
            package_level: null,
            package_unit_cn: null,
            package_unit_code: null
          // status: 0,
          // sort: 0
          }
        }
      }
    }
  },
  data() {
    return {
      // 基础数据
      show: true,
      unitpagelist:[],
      package_levellist: [
        {
          value: 1,
          label: '一级包装'
        },
        {
          value: 2,
          label: '二级包装'
        },
        {
          value: 3,
          label: '三级包装'
        },
                {
          value: 4,
          label: '四级包装'
        },
        {
          value: 5,
          label: '五级包装'
        }
      ],
      rules: {
        package_unit_cn: [
          { required: true, message: '请选择包装单位', trigger: 'blur' }
        ],
        package_level: [
          { required: true, message: '请选择包装级别', trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
    productunitpagelist({ status: 0, pageindex: 1, pagesize: 100 }).then(
      response => {
        // 获取包装单位下拉
        console.log(response.data)
        this.unitpagelist = response.data.data
      }
    )
  },
  methods: {
    // 获取包装单位名称
    getpackageunitname(e) {
      console.log(e)
      let obj = {}
      obj = this.unitpagelist.find(item => {
        return item.product_unit_code === e // 筛选出匹配数据
      })
      this.update.form.package_unit_cn = obj.product_unit_cn
    },
    // 保存提交
    submitadd(formName) {
      this.$refs[formName].validate(valid => {
        // 基础表单验证
        if (valid) {
          workorderpackedit(this.update.form).then(response => {
            if (response.status_code == 200) {
              this.$message({
                type: 'success',
                message: '修改成功!'
              })
              this.search()
              this.resetForm(formName)
              this.update.show = false
            } else {
              this.$message({
                type: 'warning',
                message: '修改失败!请检查字段'
              })
            }
          })
        } else {
          return false
        }
      })
    },
    // 清空表单数据
    resetForm(formName) {
      this.$refs[formName].resetFields()
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
